
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, AlertTriangle, XCircle } from "lucide-react";

// Sample sync log data for demonstration
const sampleSyncLog = [
  {
    id: 1,
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2), // 2 hours ago
    type: "export",
    entity: "Invoices",
    status: "success",
    message: "Successfully exported 12 invoices to Xero",
  },
  {
    id: 2,
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 12), // 12 hours ago
    type: "import",
    entity: "Contacts",
    status: "success",
    message: "Imported 5 new contacts from Xero",
  },
  {
    id: 3,
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24), // 1 day ago
    type: "export",
    entity: "Expenses",
    status: "warning",
    message: "3 expenses could not be matched to Xero accounts",
  },
  {
    id: 4,
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 48), // 2 days ago
    type: "import",
    entity: "Chart of Accounts",
    status: "error",
    message: "Authentication token expired during sync",
  },
];

// Status icon component
const StatusIcon = ({ status }: { status: string }) => {
  switch (status) {
    case "success":
      return <CheckCircle className="h-5 w-5 text-green-500" />;
    case "warning":
      return <AlertTriangle className="h-5 w-5 text-amber-500" />;
    case "error":
      return <XCircle className="h-5 w-5 text-red-500" />;
    default:
      return null;
  }
};

// Format date for display
const formatDate = (date: Date) => {
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export function XeroSyncLog() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl font-semibold">Synchronization History</CardTitle>
        <CardDescription>
          Recent data synchronization activities with Xero
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Time</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Entity</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Message</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sampleSyncLog.map((log) => (
              <TableRow key={log.id}>
                <TableCell className="font-mono">{formatDate(log.timestamp)}</TableCell>
                <TableCell className="capitalize">{log.type}</TableCell>
                <TableCell>{log.entity}</TableCell>
                <TableCell>
                  <div className="flex items-center">
                    <StatusIcon status={log.status} />
                    <span className="ml-2 capitalize">{log.status}</span>
                  </div>
                </TableCell>
                <TableCell>{log.message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
